import React, { createContext, useEffect, useState, ReactNode } from 'react';
import { Event } from '../types/Event';

interface EventContextProps {
  currentEvent: Event | null;
  setCurrentEvent: (event: Event | null) => void;
}

export const EventContext = createContext<EventContextProps>({} as EventContextProps);

export const EventProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentEvent, setCurrentEvent] = useState<Event | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem('currentEvent');
    if (stored) {
      try {
        setCurrentEvent(JSON.parse(stored));
      } catch {
        localStorage.removeItem('currentEvent');
      }
    }
  }, []);

  useEffect(() => {
    if (currentEvent) {
      localStorage.setItem('currentEvent', JSON.stringify(currentEvent));
    } else {
      localStorage.removeItem('currentEvent');
    }
  }, [currentEvent]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'currentEvent') {
        if (event.newValue) {
          try {
            setCurrentEvent(JSON.parse(event.newValue));
          } catch {
            setCurrentEvent(null);
            localStorage.removeItem('currentEvent');
          }
        } else {
          setCurrentEvent(null);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <EventContext.Provider value={{ currentEvent, setCurrentEvent }}>
      {children}
    </EventContext.Provider>
  );
};
